import { getApiToken } from "~/composables/auth";
import { useAuthStorage } from "~/composables/useAuthStorage";

export default defineNuxtRouteMiddleware(async () => {
  // Skip on server side to avoid breaking Cloudflare cache
  if (import.meta.server) {
    return;
  }

  const FF_USER_AUTH_ENABLED = useFeatureFlag("userAuthEnabled");

  // Skip authentication if feature flag is disabled
  if (!FF_USER_AUTH_ENABLED) {
    return;
  }

  const {
    getToken,
    getClientUUID,
    setToken,
    setClientUUID,
    getProfilePicture,
    setProfilePicture,
  } = useAuthStorage();

  try {
    const token = getToken();
    const clientUUID = getClientUUID();

    if (!token || !clientUUID) {
      const newTokens = await getApiToken();
      if (newTokens) {
        setToken(newTokens.token);
        setClientUUID(newTokens.clientUUID);
        // Identity dropped to anonymous — don't leave the previous user's
        // avatar URL on COOKIES_DOMAIN, where websale can read it.
        if (getProfilePicture()) setProfilePicture(null);
      } else {
      }
    }
  } catch (e) {
    // Silently fail — apiClient interceptor will handle token creation on next request
  }
});
